import type { ReactNode } from 'react';

export const symbol_flex_no_wrap: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M40-310v-340q0-12.75 8.63-21.38Q57.25-680 70-680h180q12.75 0 21.38 8.62Q280-662.75 280-650v340q0 12.75-8.62 21.37Q262.75-280 250-280H70q-12.75 0-21.37-8.63Q40-297.25 40-310Zm320 0v-340q0-12.75 8.63-21.38Q377.25-680 390-680h180q12.75 0 21.38 8.62Q600-662.75 600-650v340q0 12.75-8.62 21.37Q582.75-280 570-280H390q-12.75 0-21.37-8.63Q360-297.25 360-310Zm320 0v-340q0-12.75 8.63-21.38Q697.25-680 710-680h180q12.75 0 21.38 8.62Q920-662.75 920-650v340q0 12.75-8.62 21.37Q902.75-280 890-280H710q-12.75 0-21.37-8.63Q680-297.25 680-310Zm-580-30h120v-280H100v280Zm640 0h120v-280H740v280Z"
		/>
	</svg>
);
